module.exports = __webpack_public_path__ + "static/media/Jennifer E.af8c2fc4.png";